export const langNames = {
  en: 'English',
  heb: 'עִברִית',
  ua: 'Українська',
  th: 'ไทย',
  my: 'မြန်မာ',
  ru: 'Русский',
}

export const AVATAR_EXAMPLE = 'https://res.cloudinary.com/exsportia-ltd/image/upload/v1732751886/samples/vk7rqlirw3upictlijvl.webp'
